import styled from '@emotion/styled';
import colors from 'lib/colors';

interface StyledArrowProps {
  up: boolean;
}

const StyledArrow = ({ up }: StyledArrowProps) => (
  <ArrowStyling up={up}>&#8595;</ArrowStyling>
);

const ArrowStyling = styled('span')<StyledArrowProps>(({ up }) => ({
  height: 16,
  marginLeft: 4,
  color: colors.warning,
  fontSize: '1.2em',
  marginTop: '-0.2em',
  transform: up ? 'rotateZ(-180deg)' : 'rotateZ(0deg)',
  transition: 'all 0.3s ease',
}));

export default StyledArrow;
